import { IconButton, Link } from '@mui/material';
import {
  RootDiv,
  TitleTypography,
  CenteredWrapper,
  LeftActionContainer,
} from './SimpleHeader.styles';
import { MekiLogo } from '@components/icons/LogoMeki';
import { getRoute } from '@utils/routes';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { Theme, useTheme } from '@mui/material/styles';

const backgroundColorMap = (theme: Theme) => ({
  blue: theme.palette.primary.dark,
  white: '#fff',
});
interface SimpleHeaderProps {
  backButton?: boolean;
  handleBack?: () => void;
  homeButton?: boolean;
  homeButtonColor?: string;
  title?: string;
  color?: string;
}

export function SimpleHeader({
  backButton = false,
  handleBack: parentHandleBack,
  homeButton = false,
  homeButtonColor = 'black',
  title = null,
  color = 'blue',
}: SimpleHeaderProps) {
  const router = useRouter();
  const theme = useTheme();

  const backgroundColor = backgroundColorMap(theme)[color];

  const handleBack = useCallback(() => {
    if (parentHandleBack) {
      parentHandleBack();
    } else if (window.history.length > 2) {
      router.back();
    } else {
      router.push(getRoute('homeLoggedIn').toString());
    }
  }, [router, parentHandleBack]);

  return (
    <RootDiv backgroundColor={backgroundColor}>
      <LeftActionContainer>
        {backButton ? (
          <IconButton
            size="small"
            color="inherit"
            aria-label="back"
            onClick={handleBack}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
        ) : (
          !homeButton && (
            <Link href={getRoute('homeLoggedIn').toString()}>
              <MekiLogo height="20px" width="auto" fill={homeButtonColor} />
            </Link>
          )
        )}
      </LeftActionContainer>
      <div>
        {homeButton && (
          <Link href={getRoute('homeLoggedIn').toString()}>
            <CenteredWrapper>
              <MekiLogo height="20px" width="auto" fill={homeButtonColor} />
            </CenteredWrapper>
          </Link>
        )}
        {!homeButton && (
          <div>
            <TitleTypography>{title}</TitleTypography>
          </div>
        )}
      </div>
      <div />
    </RootDiv>
  );
}
